import { DataBean } from "../DataBean";


export class ProjectProducts extends DataBean {

    public async getProjectProductsCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectProductsCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async deleteProjectProducts(idprojectproducts: number): Promise<any> {
        return this.getCustomService("FinanceCore", "boolean_deleteProjectProducts_Number", [idprojectproducts]);
    }

    public async updateProjectProducts(bean: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.ProjectProducts_updateProjectProducts_com.orange.bean.ProjectProducts", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.orange.bean.ProjectProducts"
            }
        ]);
    }

}